import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getToken } from '../../project/helpers/Jwt';

const EntryModule = () => {
    const { id, } = useParams(); // Get 'id' from link params
    const navigate = useNavigate();    
    const [loading, setLoading] = useState(false);

    const [optionProject, setOptionProject] = useState([]);
    const [loadingProject, setLoadingProject] = useState(true);

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        category: '',
        link: '',
        description: ''
    });

    useEffect(() => {
        fetchOptionProject();
    }, [id]);

    const fetchData = async () => {
        setLoading(true);
        try {            
            await axios.get(`${process.env.REACT_APP_API_URL}/api/system/module/detail?id=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            }).then( response => {
                const { id_project, name, link, path, endpoint } = response.data.data;
                setInitialValues({
                    id_project: id_project || '',
                    name: name || '',
                    link: link || '',
                    path: path || '',
                    endpoint: endpoint || ''
                });
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchOptionProject = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/core/project/project`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });
            setOptionProject(response.data);
            fetchData();
        } catch (error) {
            alert(error);
        } finally {
            setLoadingProject(false);
        }
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        endpoint: Yup.string().required('Endpoint is required')
    });

    const onSubmit = async (values, requests) => {
        try {
            const formData = {
                id_project: values.id_project,
                name: values.name,
                path: values.path,
                endpoint: values.endpoint
            };

            if (id) {
                formData['id'] = id;
                await axios.post(`${process.env.REACT_APP_API_URL}api/system/module`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`
                    }
                });
            } else {
                await axios.post(`${process.env.REACT_APP_API_URL}api/system/module`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`
                    }
                });
            }
            
            navigate(-1);
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            requests.setSubmitting(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="mx-auto p-4 bg-white shadow-md rounded">
            <h2 className="text-2xl font-bold mb-4">Entry Form Module</h2>
            <Formik
                enableReintialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}>
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form 
                        onSubmit={handleSubmit}>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="id_project" className="block text-sm font-medium text-gray-700">
                                Project
                            </label>
                            {loadingProject ? (
                                <h1>Loading...</h1>
                            ) : (
                                <>
                                    <Field
                                        as="select"
                                        name="id_project"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                        onChange={(e) => {
                                            const selectedProjectId = e.target.value;
                                            setFieldValue("id_project", selectedProjectId);
                                        }}
                                    >
                                        <option value="" label="Pilih Project" />
                                        {optionProject.map((project) => (
                                            <option key={project.id} value={project.id}>
                                                {project.name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="id_project" component="p" className="text-red-500 text-xs mt-1" />
                                </>
                            )}
                        </div>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="name">Name</label>
                            <Field 
                                className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                type="text" name="name" />
                            <ErrorMessage name="name" component="p" className='text-red-500 text-xs mt-1'/>
                        </div>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="path">Path</label>
                            <Field 
                                className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                type="text" name="path" />
                        </div>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="description">Endpoint</label>
                            <Field 
                                className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                type="text" name="endpoint" />
                            <ErrorMessage name="endpoint" component="p" className='text-red-500 text-xs mt-1'/>
                        </div>
                        <div className="mt-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}>
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default EntryModule;
